export default __webpack_public_path__ + "static/media/factory.61983150.png";